export enum ErrorStatusEnum {
  error='error',
  failed='failed',
  http='http',
  canceled='canceled',
}

export enum ErrorCodeEnum {
  authentication='AuthenticationException',
  critical='CRITICAL_EXCEPTION',
  message='MessageException',
  validation='VALIDATION',
}

export interface ValidationErrors {
  [key: string]: string[];
}
export interface ValidationErrorResponse {
  status: ErrorStatusEnum.error | number,
  error: {
    error_code: ErrorCodeEnum.validation,
    error_message: string,
    errors: ValidationErrors,
  };
}

export interface ErrorResponse {
  status: ErrorStatusEnum | number,
  error: {
    error_code: ErrorCodeEnum.critical | ErrorCodeEnum.message,
    error_message: string,
  };
}

export interface HttpErrorResponse {
  status: 'httpStatusError' | number,
  error: {
    error_code: ErrorStatusEnum.http,
    error_message: string,
    httpStatus: number,
  };
}

export type ApiResponseErrors = (
  ErrorResponse |
  ValidationErrorResponse |
  HttpErrorResponse
)
